<!-- /** Created by azhou on 2019/3/29.*/
<template>
  <div>
    <group-room-meet-list v-if="isGroup && !storeId"/>
    <store-r-m-c-lists v-else/>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import GroupRoomMeetList from './GroupRMCList'
  import StoreRMCLists from './StoreRMCLists'

  export default {
    name: 'GroupRoomMeetBus',
    components: { GroupRoomMeetList, StoreRMCLists },
    computed: {
      ...mapGetters(['storeInfo','isGroup']),
      storeId() { return this.$route.query.storeId },
    }
  }
</script> -->
<template>
    <div>
      <public-title >
          房型资料
        <span class="text-link ml-auto h6" slot="right" @click="$router.back()" v-if="storeId">返回上一页</span>
      </public-title>
      <div class="load-area">
        <!-- <group-r-m-c-list v-if="isGroup && !storeId"></group-r-m-c-list> -->
        <room-meet-lists class="p-4 bg-white w-d"/>
      </div>
    </div>
</template>

<script>
  import { mapState,mapGetters,mapMutations } from 'vuex'
  import RoomMeetLists from './Comps/RoomMeetLists'
  import GroupRMCList from './GroupRMCList.vue'
  // import GroupHotelList from '@/views/Group/HotelList/index.vue'
  export default {
    name: 'GroupRoom',
    computed: {
      ...mapState(['currentStoreInfo']),
      ...mapGetters(['storeInfo','isGroup']),
      queryStoreId() { return this.$route.query.storeId },
      step() { return this.$route.query.step },
      storeId() { return this.$route.query.storeId },
    },
    watch:{
      step(newVal) { this.activeName = newVal; },
    },
    data() {
      return {
        activeName:''
      }
    },
    components:{ RoomMeetLists, GroupRMCList },
    mounted() {
      this.UPDATECURRENTSTORE({storeId:this.queryStoreId});
      this.activeName = this.$route.query.step + '';
    },
    destroyed() { 
      if(this.storeId){
        this.UPDATECURRENTSTORE({storeId:''}) 
      }
  },
    methods:{
      ...mapMutations(['UPDATECURRENTSTORE']),
      changeTab(tab) {
        this.$router.replace({name:this.$route.name,query:{...this.$route.query,step:tab.name}})
      }
    }
  }
</script>

